const AI_SHIFT_COMPANIES = [
  {
    company: 'Google',
    quote: 'More than 25% of new code at Google is generated by AI, then reviewed and accepted by engineers.',
    attribution: 'Sundar Pichai said this on Alphabet\'s Q3 2024 earnings call.',
    context: 'The engineers reviewing that code are still employed; the ones who can\'t are not.',
    bullets: [
      'L4/L5 interviews now include dedicated AI code review rounds.',
      'Output is measured by AI-augmented velocity.'
    ],
    stats: [
      { value: '25%+', label: 'of new code generated by AI', source: 'Alphabet Q3 earnings call, Oct 2024' },
      { value: '12K', label: 'roles cut in 2023', source: 'Reuters, Jan 2023' }
    ]
  },
  {
    company: 'Amazon',
    quote: 'Amazon says Q helped migrate 30,000+ production Java applications and saved 4,500 developer-years.',
    attribution: 'These are Amazon-reported internal estimates from AWS leadership.',
    context: 'A team of 5 now ships like a team of 15. Headcount isn\'t coming back.',
    bullets: [
      'Backend JDs now require AI-assisted development experience.'
    ],
    stats: [
      { value: '4.5K', label: 'developer-years saved (Amazon estimate)', source: 'AWS DevOps blog, 2024' },
      { value: '27K', label: 'major layoffs in 2022–2023', source: 'Bloomberg tracking, 2023' }
    ]
  },
  {
    company: 'Meta',
    quote: 'In 2025, AI will write code at the level of a mid-level engineer.',
    attribution: 'Zuckerberg said this on the Joe Rogan podcast (Jan 2025). Meta restructured around AI-augmented teams.',
    context: 'The "Year of Efficiency" — mid-level engineers now need to lead, not implement.',
    bullets: [
      'New hires are screened for AI-system design from day one.'
    ],
    stats: [
      { value: '21K', label: 'roles cut across 2022–2023 efficiency rounds', source: 'Reuters, Meta announcements' },
      { value: '2025', label: 'target year Zuckerberg cited for mid-level coding AI', source: 'Joe Rogan podcast, Jan 2025' }
    ]
  },
  {
    company: 'Klarna',
    quote: 'Our AI assistant does the work of 700 full-time agents. We\'ve stopped backfilling.',
    attribution: 'Klarna\'s AI handles 2/3 of all customer service chats — in the first month.',
    context: 'Klarna reported shrinking headcount via attrition while increasing AI-assisted support.',
    bullets: [
      'Remaining engineers must own AI-integrated systems.'
    ],
    stats: [
      { value: '700', label: 'full-time-equivalent support workload handled by AI', source: 'Klarna company statement, Feb 2024' },
      { value: '$40M', label: 'estimated annual profit improvement', source: 'Klarna company statement, 2024' }
    ]
  }
];

export default AI_SHIFT_COMPANIES;
